import { request } from './client';

export const apiGetAvailableCoupons = () => request('/coupons/available');
export const apiGetUsedCoupons = () => request('/coupons/used');
export const apiGetPublicCoupons = () => request('/coupons/public');

export const apiValidateCoupon = (code, cartTotal, currencyCode = 'INR') =>
  request('/coupons/validate', { method: 'POST', body: { code, cartTotal, currencyCode } });
